module.exports = __webpack_public_path__ + "static/img/FISURAS.abbeefc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/FISURAS.jpg
// module id = T1dK
// module chunks = 2